import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const SubscriptionModalStyled = styled(IonModal)`
  --background: #177590;
  --width: 100%;
  --height: 100%;

  ion-toolbar {
    --background: #177590;

    ion-icon {
      color: #ffffff !important;
    }
  }

  ion-content {
    --background: #177590;
  }

  ion-header {
    background: #177590;
  }
`;

export const SubscriptionModalContainer = styled.div`
  padding-bottom: 50px;

  .info-icon {
    margin-bottom: 30px;
  }

  .subscription-info {
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: #ffffff;
    margin-bottom: 35px;

    b {
      font-weight: 600;
    }
  }

  .subscription-date-wrapper {
    color: #ffffff;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    b {
      font-weight: 600;
    }

    .subscription-date {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

    .subscription-date-progress {
      --background: #ffffff;
      --progress-background: #26b183;
      height: 7px;
      border-radius: 9px;

      &::part(progress) {
        border-radius: 9px;
      }
    }
  }

  .subscription-balance-wrapper {
    color: #ffffff;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    b {
      font-weight: 600;
    }

    .subscription-balance {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

    .balance-list {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      column-gap: 8px;

      .balance-item {
        flex: 1;
        width: 100%;
        height: 7px;
        background: #e5e5e5;
        border-radius: 10px;

        &.filled {
          background: #26b183;
        }
      }
    }
  }

  .help-btn {
    color: #ffffff;
    margin-bottom: 68px;
  }

  .modal-desc {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #ffffff;
    margin-bottom: 20px;
  }

  .booking-btn {
    background: #f24e1e;
    margin-bottom: 10px;
  }

  .cancel-btn {
    background: transparent;
    border: 1px solid #ffffff;
  }
`;
